// ToDo: temporary enum ?
export enum KnmErknmStatusIdsByCodeEnum {
  FILL_IN_PROCESS = 11,
  READY_FOR_APPROVE = 12,
  APPROVING = 13,
  NOT_APPROVE = 14,
  REJECTED = 15,
  COMMENTS_EXIST = 16,
  REJECT_APPEALED = 17,
  DECISION_APPEALED = 21,
  TYPE_WAITING_CARRY_OUT = 5,
  TYPE_CARRIED_OUT = 6,
  TYPE_COMPLETED = 7,
  TYPE_DISAPPROVED = 4,
  TYPE_CANT_BE_CARRY_OUT = 8,
  REJECT = 22,
  REMARK = 23,
  APPEALED = 24,
}
